// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"326":"website","593":"miniProgram"}[chunkId] + "." + {"326":"bbf7c001","593":"fcb4762a"}[chunkId] + ".css";
};